import React, { FC, useEffect, useRef, useState } from "react";
import { Typography, TextField, Box, Grid, Button } from '@material-ui/core';
import { Visibility, VisibilityOff } from "@material-ui/icons"
import { useDispatch, useSelector } from "react-redux";
import { SetChargePackage, SetStatus } from "../../redux/chargePackage/actions";
import { chargeWalletPackage } from "../../services/api/walletCharge"
import { useHistory } from "react-router-dom";
import { ApplicationState } from "../../redux";
import Loader from "../../components/loader";
import { InternetWalletBuyApi } from "../../services/api/InternetPackage";
// @ts-ignore
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import CustomInputNumber from "../../components/input-number"
import InputNumberIconed from "../../components/InputNumberIconed"
import "./style.scss";

const Gateway: FC = () => {
    const [pass, setPass] = useState(false)
    const [formValue, setFormValue] = useState<any>({
        "user_pan": undefined,
        "second_password": undefined,
        "cvv2": undefined,
        "expire_year": undefined,
        "expire_month": undefined,
    })
    const [formErr, setFormErr] = useState<any>({})
    const [state, setState] = useState<any>({
        redirect: false,
        loading: false,
        to: ""
    })
    const [check, setCheck] = React.useState({
        checkedA: true,
        checkedB: true,
    });
    const [key, setKey] = useState<boolean>()
    const history = useHistory()
    const dispatch = useDispatch()

    const cvv2Ref = useRef<any>(null);
    const monthRef = useRef<any>(null);
    const yearRef = useRef<any>(null);
    const pinRef = useRef<any>(null);
    const capRef = useRef<any>(null);

    const { info, type } = useSelector(({ payment }: any) => payment)
    const { access_token } = useSelector(({ authorization }: ApplicationState) => authorization)

    useEffect(() => {
        if (!access_token) {
            setState({
                ...state,
                redirect: true,
                to: "/"
            })
        }

        loadCaptchaEnginge(4)
    }, [])

    const handleFormValue = (name: any, value: any) => {
        setFormValue({
            ...formValue,
            [name]: value
        })
    }


    const valid = ({ target: { name, value } }: any) => {
        switch (name) {
            case 'user_pan':
                if (value.length < 17) {
                    handleFormValue(name, value)
                } else {
                    cvv2Ref && cvv2Ref.current.focus();
                }
                break;
            case 'expire_year':
                if (value.length < 3) {
                    handleFormValue(name, value)
                } else {
                    monthRef && monthRef.current.focus();
                }
                break;
            case 'expire_month':
                if (value.length <= 2 && (parseInt(value) < 13 || !value)) {
                    handleFormValue(name, value)
                } else {
                    pinRef && pinRef.current.focus();
                }
                break;
            case 'cvv2':
                if (value.length < 5) {
                    handleFormValue(name, value)
                } else {
                    yearRef && yearRef.current.focus();
                }
                break;
            case 'second_password':
                if (value.length < 11) {
                    handleFormValue(name, value)
                } else {
                    capRef && capRef.current.focus();
                }
                break;
            case "cap":
                if (value.length < 5) {
                    handleFormValue(name, value)
                }
                break;
            default:
                handleFormValue(name, value)
        }
    }

    const validate = (submit: any) => {
        let _errors = {}
        let hasError = false
        Object.keys(formValue).map((item: any) => {
            // @ts-ignore
            if (!formValue[item]) {
                _errors = { ..._errors, [item]: `این فیلد اجباریست` }
                hasError = true
            } else if (formValue['user_pan']?.length < 16) {
                _errors = { ..._errors, ['user_pan']: `شماره کارت باید 16 رقم باشد` }
                hasError = true
            }

        })
        setFormErr(_errors)
        if (!hasError) submit()
    }


    const handlePass = () => {
        setPass(!pass)
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCheck({ ...check, [event.target.name]: event.target.checked });
    };

    const onSubmit = async () => {
        if (validateCaptcha(formValue['cap']) == true) {
            setState({
                redirect: false,
                loading: true,
                ...state
            })
            if (type === 1) {
                const res = await chargeWalletPackage({
                    ...formValue,
                    ...info,
                    "cvv2": parseInt(formValue["cvv2"]),
                    "expire_year": parseInt(formValue["expire_year"]),
                    "expire_month": parseInt(formValue["expire_month"]),
                    "amount": parseInt(info["amount"]),
                })
                if (res) {
                    console.log(res)
                    console.log(res.data)
                    const { data } = res;
                    dispatch(SetChargePackage({
                        ...formValue,
                        "cvv2": parseInt(formValue["cvv2"]),
                        "expire_year": parseInt(formValue["expire_year"]),
                        "expire_month": parseInt(formValue["expire_month"]),
                        "amount": parseInt(info["amount"]),
                        ...info,
                        ...data
                    }))

                    if (res.status >= 300) {
                        dispatch(SetStatus("fail"))
                    } else {
                        dispatch(SetStatus("success"))
                    }

                    setState({
                        redirect: true,
                        loading: false,
                        to: "/transaction"
                    })
                }
            } else {
                const res = await InternetWalletBuyApi({
                    ...formValue,
                    'package_id': info.package_id,
                    'package_title': info.package_title,
                    'mobile_number': info.mobile_number,
                    'operator_type_id': info.type_operator_id,
                    'simcard_type_id': info.type_simcard_id,
                    'package_type_id': info.package_type_id,
                    'package_type_title': info.package_type_title,
                    "cvv2": parseInt(formValue["cvv2"]),
                    "expire_year": parseInt(formValue["expire_year"]),
                    "expire_month": parseInt(formValue["expire_month"]),
                    "amount": parseInt(info["amount"]),
                })
                if (res) {
                    const { data } = res;
                    dispatch(SetChargePackage({
                        ...info,
                        ...formValue,
                        ...data,
                        "cvv2": parseInt(formValue["cvv2"]),
                        "expire_year": parseInt(formValue["expire_year"]),
                        "expire_month": parseInt(formValue["expire_month"]),
                        "amount": parseInt(info["amount"]),
                    }))
                    setState({
                        redirect: true,
                        loading: false,
                        to: "/transaction"
                    })

                    if (res.status >= 300) {
                        dispatch(SetStatus("fail"))
                    } else {
                        dispatch(SetStatus("success"))
                    }
                }
            }
        } else {
            setFormErr({
                ...formErr,
                'cap': "کد اشتباه است"
            })
        }
    }

    if (state.redirect)
        history.push(state.to)


    return (

        <Loader loading={state.loading} >
            <div className="main pt-4">
                <Grid container>
                    <Grid item xl={4} className="mx-auto">
                        {/* @ts-ignore */}
                        <Box className="main-container pb-4 text-right">
                            {/* @ts-ignore */}
                            <Box display="flex" justifyContent="center" className="head-content text-white py-3 mt-4">
                                <Typography>اطلاعات کارت</Typography>
                            </Box>
                            <Grid container alignItems="center" className="justify-content-center mt-2" spacing={2}>
                                <Grid item xs={7}>
                                    {/* @ts-ignore */}
                                    <Box>
                                        <Typography className="helperText text-muted">شماره 16 رقمی روی کارت خود را وارد کنید</Typography>
                                        <CustomInputNumber
                                            size="small"
                                            variant="outlined"
                                            className="w-100 textField"
                                            name={'user_pan'}
                                            value={formValue['user_pan']}
                                            onChange={valid}
                                        />
                                        <Typography className="textError">{formErr && formErr['user_pan']}</Typography>

                                    </Box>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography className="smaller font-weight-bold">شماره کارت اعتباری</Typography>
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" className="justify-content-center mt-2" spacing={2}>
                                <Grid item xs={7}>
                                    {/* @ts-ignore */}
                                    <Box>
                                        <CustomInputNumber
                                            size="small"
                                            variant="outlined"
                                            className="w-100 textField"
                                            name={'cvv2'}
                                            value={formValue['cvv2']}
                                            onChange={valid}
                                            inputRef={cvv2Ref}
                                        />
                                        <Typography className="textError">{formErr && formErr['cvv2']}</Typography>

                                    </Box>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography className="smaller font-weight-bold">cvv2</Typography>
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" className="justify-content-center mt-2" spacing={2}>
                                <Grid item xs={7}>
                                    {/* @ts-ignore */}
                                    <Box className="field-container py-2" display="flex">
                                        <CustomInputNumber
                                            size="small"
                                            variant="outlined"
                                            className="w-100 textField date"
                                            placeholder="سال"
                                            name={'expire_year'}
                                            value={formValue['expire_year']}
                                            onChange={valid}
                                            inputRef={yearRef}

                                        />
                                        <CustomInputNumber
                                            size="small"
                                            variant="outlined"
                                            className="w-100 textField border-left-style date"
                                            placeholder="ماه"
                                            name={"expire_month"}
                                            value={formValue['expire_month']}
                                            onChange={valid}
                                            inputRef={monthRef}

                                        />
                                    </Box>
                                    {/* @ts-ignore */}
                                    <Box display={"flex"}>
                                        {/* @ts-ignore */}
                                        <Box style={{ width: "50%" }}>
                                            <Typography className="textError">{formErr && formErr['expire_year']}</Typography>
                                        </Box>
                                        {/* @ts-ignore */}
                                        <Box style={{ width: "50%" }}>
                                            <Typography className="textError">{formErr && formErr['expire_month']}</Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography className="smaller font-weight-bold">انقضا</Typography>
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" className="justify-content-center mt-2" spacing={2}>
                                <Grid item xs={7}>
                                    {/* @ts-ignore */}
                                    <Box className="passField-container">
                                        <InputNumberIconed
                                            placeholder={'رمز دوم'} name={'second_password'} adornment={pass ? <VisibilityOff /> : <Visibility />}
                                            onAdornmentClick={handlePass} type={pass ? 'number' : 'password'}
                                            inputRef={pinRef}
                                            onChange={valid} value={formValue['second_password']} className={'pin'}
                                        />
                                        <Typography className="textError">{formErr && formErr['second_password']}</Typography>

                                    </Box>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography className="smaller font-weight-bold">رمز دوم</Typography>
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" className="justify-content-center mt-2" spacing={2}>
                                <Grid item xs={7}>
                                    {/* @ts-ignore */}
                                    <Box display="flex" alignItems={"center"} className={'captcha'}>
                                        <LoadCanvasTemplate reloadText={" "} />
                                        {/* @ts-ignore */}
                                        <Box>
                                            <TextField
                                                required
                                                name="cap"
                                                label={"کد را وارد نمایید "}
                                                margin="normal"
                                                onChange={valid}
                                                value={formValue['cap']}
                                                variant="outlined"
                                                style={{ width: "100%" }}
                                                inputRef={capRef}
                                            />
                                            <Typography className="textError">{formErr && formErr['cap']}</Typography>
                                        </Box>

                                    </Box>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography className="smaller font-weight-bold">کد امنیتی</Typography>
                                </Grid>
                            </Grid>
                            <Grid container alignItems="center" className="justify-content-center mt-2" spacing={2}>
                                <Grid item xs={7}>
                                    {/* @ts-ignore */}
                                    <Box display="flex" className="flex-revers" alignItems="center">
                                    </Box>
                                </Grid>
                                <Grid item xs={3}>

                                </Grid>
                            </Grid>
                            <Grid container spacing={2} justifyContent="center">
                                <Grid item xs={5}>
                                    <Button variant="outlined" className="w-100 back btns outline-btn" onClick={() => setState({ ...state, redirect: true, to: "/" })} >
                                        انصراف
                                    </Button>
                                </Grid>
                                <Grid item xs={5}>
                                    <Button variant="contained" color="primary" className="w-100 btns linear-btn" onClick={() => validate(onSubmit)} >
                                        پرداخت
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </Grid >
            </div >
        </Loader>
    );
};

export default Gateway;
